<template>
    <DModal
        :title="$t('common.delete_confirm_title')"
        :show="showModal"
        is-confirm
        is-error
        @close="$emit('close-delete-modal')"
        @confirm="$emit('delete-confirmed')"
    >
        <div
            v-if="showModal"
            class="m-3"
        >
            {{ $t('certificates.delete_confirm_body') }}
        </div>
    </DModal>
</template>

<script>
export default {
    name: 'CertificateDeleteModal',
    props: {
        showModal: {
            type: Boolean,
            default: false
        }
    },
    emits: ['close-delete-modal', 'delete-confirmed']
}
</script>
